import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getWallet = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/wallet`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessExecutives = async (
  dispatch: Dispatch,
  businessIdentifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/${businessIdentifier}/executives`,
    dispatch,
  });
  if (response) return response.data;
};
